import { Layer } from 'shared/map-exports';
import { getWatchdutyStaticTileUrl } from 'features/mapping/components/layers/layers.utils';
import { useStaticTileCacheDomain } from 'features/mapping/hooks/useStaticTileCacheDomain';
import {
  BELOW_STREETS_LAYER_ID,
  ON_TOP_OF_EVERYTHING_LAYER_ID,
} from 'features/mapping/styles/constants';
import { VisibilityToggledSource } from '../VisibilityToggledSource';
import { FEDERAL_LANDS_SOURCE_ID } from './constants';
import {
  layerBorderStyle,
  layerFillStyle,
  layerLabelStyle,
} from './layerStyles';

type FederalLandsLayerProps = {
  visible: boolean;
};

export const FederalLandsLayer = (
  props: FederalLandsLayerProps,
): JSX.Element => {
  const { visible } = props;
  const staticTileCacheDomain = useStaticTileCacheDomain();

  return (
    <VisibilityToggledSource
      url={getWatchdutyStaticTileUrl('land_ownership', staticTileCacheDomain)}
      visible={visible}
      id={FEDERAL_LANDS_SOURCE_ID}
    >
      <Layer beforeId={BELOW_STREETS_LAYER_ID} {...layerFillStyle} />
      <Layer beforeId={BELOW_STREETS_LAYER_ID} {...layerBorderStyle} />
      <Layer beforeId={ON_TOP_OF_EVERYTHING_LAYER_ID} {...layerLabelStyle} />
    </VisibilityToggledSource>
  );
};
